import defaultState from './state.js'
import router from '@/router.js'

export default {
    RESET_STATE(state) {
        Object.assign(state, defaultState);
    },
    FETCH_INVITE(state, response) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('role', response.data.role?response.data.role:'specialist');
        localStorage.setItem('invite_step', response.data.specialist.invite_step);

        state.currentStep = response.data.specialist.invite_step;

        // Break specialist object's values in wizard steps
        state.steps[1].payload = {
            first_name: response.data.specialist.first_name,
            last_name: response.data.specialist.last_name,
            dob: response.data.specialist.dob
        };

        state.steps[2].payload = {
            image_url: response.data.specialist.image_url,
            // video_url: response.data.specialist.video_url
        };

        state.steps[3].payload = {
            title: response.data.specialist.title,
            base_price: response.data.specialist.base_price,
            minute_base_price: response.data.specialist.minute_base_price,
            min_services: response.data.specialist.min_services,
        };

        var defaults = ['about', 'experience', 'education'];
        var index = defaults.indexOf(response.data.specialist.default);

        if(index == -1)
            state.steps[4].payload.selectedIndex = 0;
        else
            state.steps[4].payload.selectedIndex = index;
        state.steps[4].payload.descriptions = [
            {
                id: 1,
                name: 'Despre mine',
                active: state.steps[4].payload.selectedIndex == 0,
                value: response.data.specialist.about?response.data.specialist.about:''
            },
            {
                id: 2,
                name: 'Servicii oferite',
                active: state.steps[4].payload.selectedIndex == 1,
                value: response.data.specialist.experience?response.data.specialist.experience:''
            },
            {
                id: 3,
                name: 'Beneficii',
                active: state.steps[4].payload.selectedIndex == 2,
                value: response.data.specialist.education?response.data.specialist.education:''
            }
        ];


        var splittedTimetable = null;
        var days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
        days.forEach((day, i) => {
            response.data.specialist.timetable[day].forEach((interval, i) => {
                var splittedTime = interval.start_time.split(':');

                interval.start_time = {
                    "HH": splittedTime[0],
                    "mm": splittedTime[1]
                }
                splittedTime = interval.end_time.split(':');
                interval.end_time = {
                    "HH": splittedTime[0],
                    "mm": splittedTime[1]
                }
            });
        });

        state.steps[5].payload = {
            appointments: response.data.specialist.available,
            anytimeServices: response.data.specialist.overtime,
            timetable: response.data.specialist.timetable
        };
    },
    SETTINGS(state, response) {
        if(response.status == 200) {
            state.steps[1].payload = {
                first_name: response.data.user.first_name,
                last_name: response.data.user.last_name,
                dob: response.data.user.dob,
            };

            state.steps[2].payload = {
                image_url: response.data.user.image_url,
                // video_url: response.data.user.video_url
            };

            state.steps[3].payload = {
                title: response.data.user.title,
                base_price: response.data.user.service_price,
                minute_base_price: response.data.user.minute_base_price,
                min_services: response.data.user.min_services,
            };

            var defaults = ['about', 'experience', 'education'];
            var index = defaults.indexOf(response.data.user.default);

            if(index == -1)
                state.steps[4].payload.selectedIndex = 0;
            else
                state.steps[4].payload.selectedIndex = index;
            state.steps[4].payload.descriptions = [
                {
                    id: 1,
                    name: 'Despre mine',
                    active: state.steps[4].payload.selectedIndex == 0,
                    value: response.data.user.about?response.data.user.about:''
                },
                {
                    id: 2,
                    name: 'Servicii oferite',
                    active: state.steps[4].payload.selectedIndex == 1,
                    value: response.data.user.experience?response.data.user.experience:''
                },
                {
                    id: 3,
                    name: 'Beneficii',
                    active: state.steps[4].payload.selectedIndex == 2,
                    value: response.data.user.education?response.data.user.education:''
                }
            ];

            if(response.data.user.timetable) {
                var splittedTimetable = null;
                var days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

                days.forEach((day, i) => {
                    response.data.user.timetable[day].forEach((interval, i) => {
                        var splittedTime = interval.start_time.split(':');

                        interval.start_time = {
                            "HH": splittedTime[0],
                            "mm": splittedTime[1]
                        }
                        splittedTime = interval.end_time.split(':');
                        interval.end_time = {
                            "HH": splittedTime[0],
                            "mm": splittedTime[1]
                        }
                    });
                });

                state.steps[5].payload = {
                    appointments: response.data.user.available,
                    anytimeServices: response.data.user.overtime,
                    timetable: response.data.user.timetable
                };
            }
        }
    },
    UPDATE_PASSWORD(state) {
        state.steps[0].payload.password = '';
        state.steps[0].payload.password_confirmation = '';
    },
    COUNTRIES(state, data) {
        state.countries = data.countries;
        
        if(data.hasOwnProperty('default_country'))
            state.defaultCountry = data.default_country;
    },
    UPDATE_IMAGE(state, data) {
        state.steps[2].payload.image_url = data.image_url;
    },
    UPDATE_VIDEO(state, data) {
        state.steps[2].payload.video_url = data.video_url;
    },
    UPDATE_DETAILS(state, data) {
        switch(data.type) {
            case 'profile': {
                state.steps[1].payload.first_name = response.first_name;
                state.steps[1].payload.last_name = response.last_name;
                state.steps[1].payload.dob = response.dob;
                break;
            }
            case 'titleAndBasePrice': {
                state.steps[3].payload.title = response.title;
                state.steps[3].payload.base_price = response.base_price;
                state.steps[3].payload.minute_base_price = response.minute_base_price;
                state.steps[3].payload.min_services = response.min_services;
                break;
            }
        }
    },
    UPDATE_TIMETABLE(state, response) {
        // Clear wizard state
        state.steps[5].payload = {
            appointments: true,
            anytimeServices: true,
            timetable: {}
        };
        if(router.currentRoute.name == 'Setare profil')
            router.push('/specialist/stats');
    }
}
